module.exports = __webpack_public_path__ + "media/images/mailer/logo-94893dafb0a24a483316d27617285a50.svg";